export default Object.freeze({
  Search: 'search',
  SearchClassifyFull: 'search_classify_full',
  SearchActions: 'search_actions',
  OngoingActions: 'ongoing_actions',
  ActionsApplyTag: 'actions_apply_tag',
  Retro: 'retro',
  Rules: 'rules',
});
